import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const MotorTypeForm = () => {
  const [motorTypeName, setMotorTypeName] = useState('');
  const [motorTypes, setMotorTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Neues Feld
  const [newMotorTypeId, setNewMotorTypeId] = useState('');

  // Bearbeitungs‑States
  const [editingMotorId, setEditingMotorId] = useState(null);
  const [editedMotorName, setEditedMotorName] = useState('');
  const [editedSortOrder, setEditedSortOrder] = useState('');
  const [editedMotorTypeId, setEditedMotorTypeId] = useState('');

  // Laden & Sortieren
  const fetchMotorTypes = async () => {
    try {
      const response = await api.get('/motortypes');
      const sorted = response.data.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      setMotorTypes(sorted);
    } catch (error) {
      console.error("Fehler beim Laden der Motorisierungen:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMotorTypes();
  }, []);

  // Hinzufügen
  const handleAddMotorType = async () => {
    if (!motorTypeName) {
      alert('Bitte einen Namen für die Motorisierung eingeben!');
      return;
    }
    try {
      await api.post('/motortypes', {
        name: motorTypeName,
        srrMotorTypeId: newMotorTypeId
      });
      setMotorTypeName('');
      setNewMotorTypeId('');
      fetchMotorTypes();
    } catch (error) {
      console.error("Fehler beim Hinzufügen der Motorisierung:", error);
      alert('Fehler beim Hinzufügen der Motorisierung');
    }
  };

  // Löschen
  const handleDeleteMotorType = async (id) => {
    try {
      await api.delete(`/motortypes/${id}`);
      setMotorTypes(motorTypes.filter(m => m.id !== id));
      alert('Motorisierung gelöscht!');
    } catch (error) {
      console.error('Fehler beim Löschen der Motorisierung:', error);
      alert('Fehler beim Löschen der Motorisierung');
    }
  };

  // Bearbeiten starten
  const handleEditMotorType = (motor) => {
    setEditingMotorId(motor.id);
    setEditedMotorName(motor.name);
    setEditedSortOrder(motor.sortOrder !== undefined ? motor.sortOrder : '');
    setEditedMotorTypeId(motor.srrMotorTypeId || '');
  };

  // Bearbeiten abbrechen
  const handleCancelEdit = () => {
    setEditingMotorId(null);
    setEditedMotorName('');
    setEditedSortOrder('');
    setEditedMotorTypeId('');
  };

  // Aktualisieren
  const handleUpdateMotorType = async (id) => {
    try {
      await api.put(`/motortypes/${id}`, {
        name: editedMotorName,
        sortOrder: editedSortOrder ? parseInt(editedSortOrder, 10) : 0,
        srrMotorTypeId: editedMotorTypeId
      });
      setEditingMotorId(null);
      fetchMotorTypes();
    } catch (error) {
      console.error("Fehler beim Aktualisieren der Motorisierung:", error);
      alert("Fehler beim Aktualisieren der Motorisierung: " + error.message);
    }
  };

  if (loading) {
    return <div>Daten werden geladen...</div>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '800px' }}>
        <Helmet>
          <title>Motortypen bearbeiten</title>
          <meta name="description" content="Motortypen bearbeiten" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Motorisierungen verwalten</h2>

        {/* 3‑Spaltiges Hinzufügen‑Formular */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr auto',
          gap: '10px',
          marginBottom: '20px',
          alignItems: 'center'
        }}>
          <input
            type="text"
            value={motorTypeName}
            onChange={e => setMotorTypeName(e.target.value)}
            placeholder="Name"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="text"
            value={newMotorTypeId}
            onChange={e => setNewMotorTypeId(e.target.value)}
            placeholder="srrMotorTypeId"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="number"
            value={''}
            disabled
            placeholder="Reihenfolge"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid transparent' }}
          />
          <button
            onClick={handleAddMotorType}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Hinzufügen
          </button>
        </div>

        {/* 3‑Spaltige Listenansicht */}
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {motorTypes.map(motor => (
            <li
              key={motor.id}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr auto',
                gap: '10px',
                alignItems: 'center',
                padding: '8px 0',
                borderBottom: '1px solid #ddd'
              }}
            >
              {editingMotorId === motor.id ? (
                <>
                  <input
                    type="text"
                    value={editedMotorName}
                    onChange={e => setEditedMotorName(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="text"
                    value={editedMotorTypeId}
                    onChange={e => setEditedMotorTypeId(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="number"
                    value={editedSortOrder}
                    onChange={e => setEditedSortOrder(e.target.value)}
                    placeholder="Sort"
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <div>
                    <button onClick={() => handleUpdateMotorType(motor.id)} style={{ marginRight: '5px' }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{motor.name}</span>
                  <span>{motor.srrMotorTypeId}</span>
                  <span>{motor.sortOrder}</span>
                  <div>
                    <button onClick={() => handleEditMotorType(motor)} style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#007bff', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}>
                      Bearbeiten
                    </button>
                    <button onClick={() => handleDeleteMotorType(motor.id)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#dc3545', // Rot für Löschen
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}>
                      Löschen
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MotorTypeForm;
